"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledActionsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledActionsContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0;
  padding: ${({ theme }) => theme.spacing(0, 1)};

  .attribute-header-actions {
    display: flex;
    align-items: center;
  }

  && .action-delete:hover {
    color: ${({ theme }) => theme.palette.error.dark};
    background-color: ${({ theme }) => theme.palette.error.light};
  }

  .selected-items-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
